module.exports = __webpack_public_path__ + "img/colorlogo.5c668c92.png";